import React, { useState, useEffect, useRef, useCallback } from "react";
import { Text } from "components";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import pdfMake from "pdfmake/build/pdfmake";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import Select from "react-select";
import { pageSize } from "../../components/PaginationPageSize";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ToastContainer, toast } from "react-toastify";
import { BsBoxArrowInRight, BsDownload } from "react-icons/bs";
import { FaCheck, FaEye, FaFilePdf } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import Swal from "sweetalert2";
import { FaRegEdit, FaRegFilePdf } from "react-icons/fa";
import actionbuttonCustomStyle, {
  CustomOption,
} from "styles/actionbuttonCustomStyle.";
import Pagination from "pages/Pagination/Pagination";
import StatusCapsule from "components/SmallComponents/StatusCapsule";
import Code from "components/SmallComponents/Code";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function DelivaryChallanList() {
  const [delivaryChallan, setDelivaryChallan] = useState([]);
  const gridRef = useRef();
  const selectRef = useRef();
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  sessionStorage.setItem("tab", "Raw Material");
  const [loading, setLoading] = useState(true); // State for loading indicator

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id === 51 && item.update
  );
  const showViewColumn = erplist.some(
    (item) => item.erp_module_id === 51 && item.view
  );

  const showPageView = erplist.some(
    (item) => item.erp_module_id === 51 && item.view
  );

  // for pagination ...
  const [count, setCount] = useState();
  const [recordPerPage, setRecordPerPage] = useState(pageSize);

  //for search fuctionallity ..
  const [selectedOption, setSelectedOption] = useState("column");
  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);
  const [offsetforSR, setOffsetforSR] = useState();

  const [searchCompanySpecificCriteriaId, setsearchCompanySpecificCriteriaId] =
    useState();
  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();

  //for cloumn
  const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
    useState([]);
  useEffect(() => {
    getsearchCompanySpecificCriteria();
    getsetsearchcompanyspecificdaterange();
  }, []);

  const getsearchCompanySpecificCriteria = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 10 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //for date
  const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
    useState([]);
  const getsetsearchcompanyspecificdaterange = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificdaterange/get",
        {},
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchcompanyspecificdaterange(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //for updating DC typ.....

  const updateDeliveryChallanType = (id) => {
    axios
      .post(
        "/api/purple-fusion/delivarychallan/update/dctypefromreturnabletononreturnableinv",
        { delivery_challan_id: id },
        headers
      )
      .then((res) => {
        console.log(res.data);
        const message = res.data.message;
        if (res.data.status) {
          toast.success(message, {
            autoClose: 1000,
          });
        } else {
          toast.error(message, {
            autoClose: 1000,
          });
        }
        getAllDelivaryChallan();
      });
  };

  //for getting the list of delivery challan...

  useEffect(() => {
    if (searchCompanySpecificDateRangeId != 7 && page) {
      getAllDelivaryChallan();
    }
  }, [
    page,
    recordPerPage,
    searchCompanySpecificCriteriaId,
    searchCompanySpecificDateRangeId,
    searchParameter,
  ]);

  useEffect(() => {
    if (
      formDate != "" &&
      toDate != "" &&
      searchParameter2 != "" &&
      searchCompanySpecificDateRangeId == 7 &&
      page
    ) {
      obj.search_parameter = searchParameter2;
      getAllDelivaryChallan();
    }
  }, [
    page,
    // recordPerPage,
    searchParameter2,
  ]);

  //by deafult value select
  useEffect(() => {
    if (searchCompanySpecificCriteria.length > 0) {
      // Set the default selected criteria ID when the criteria list is available
      setsearchCompanySpecificCriteriaId(searchCompanySpecificCriteria[0].id);
    }
  }, [searchCompanySpecificCriteria]);

  const obj = {
    search_company_specific_criteria_id:
      searchCompanySpecificCriteriaId != undefined
        ? searchCompanySpecificCriteriaId
        : "",
    search_company_specific_date_range_id:
      searchCompanySpecificDateRangeId != undefined
        ? searchCompanySpecificDateRangeId
        : "",
    search_parameter: searchParameter,
  };

  const getAllDelivaryChallan = () => {
    var offset = (page - 1) * recordPerPage;
    setOffsetforSR((page - 1) * recordPerPage);
    var limit = recordPerPage;

    const requestPayload = {
      ...obj, // Include other properties from obj
      offset,
      limit,
    };

    console.log(requestPayload);

    axios
      .post(
        "/api/purple-fusion/delivarychallan/get/forsearchandpagging",
        requestPayload,
        { ...headers, timeout: 20000 }
      )
      .then((response) => {
        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          setDelivaryChallan(response.data);
          setCount(response.data[0].count);
        } else {
          setDelivaryChallan([]);
          setCount(0);
        }
        setLoading(false);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
        // navigate("*");
      });
  };
  const sorteddelivaryChallan = delivaryChallan
    .slice()
    .sort((a, b) => b.id - a.id);

  const SubmitTaxInvoice = (value, typeId) => {
    console.log(value + "  " + typeId);
    axios
      .put(
        "/api/purple-fusion/delivarychallan/updatesubmitstatus",
        {
          id: value,
          delivery_challan_type_id: typeId,
        },
        headers
      )
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 1000,
            })
          : toast.error(message, {
              autoClose: 1000,
            });
        getAllDelivaryChallan();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleButtonClick = async (params, filename) => {
    try {
      const requestData = {
        delivery_challan_id: params,
        delivery_challan_type_id: "2",
      };
      console.log(requestData);

      const response = await axios.post(
        "/api/purple-fusion/deliverychallandocuments/downloads",
        requestData,
        {
          ...headers,
          responseType: "arraybuffer",
        }
      );
      // const contentDisposition = response.headers["content-disposition"];
      const FileName = response.headers["content-disposition"];
      const contentType = response.headers["content-type"];
      const blob = new Blob([response.data], { type: contentType });

      // Check if the Blob type is supported before creating an Object URL
      if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
        const arrayBuffer = await blob.arrayBuffer();
        const url = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: contentType })
        );

        // Open a new tab and set its location to the Object URL
        // window.open(url);

        const a = document.createElement("a");
        a.href = url;
        // a.download = `${FileName}.${contentType.substr(12,15)}`;
        a.download = `${filename}.pdf`;
        document.body.appendChild(a);
        // Trigger a click event to start the download
        a.click();
        // Remove the download link from the DOM
        document.body.removeChild(a);
        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } else {
        console.error(
          "Blob.arrayBuffer is not supported. Unable to create Object URL."
        );
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.warning("Unable to download file. Please try again later.");
    }
  };
  const handleButtonClick1 = async (params, filename) => {
    try {
      const requestData = {
        delivery_challan_id: params,
        delivery_challan_type_id: "1",
      };
      console.log(requestData);
      const response = await axios.post(
        "/api/purple-fusion/deliverychallandocuments/downloads",
        requestData,
        {
          ...headers,
          responseType: "arraybuffer",
        }
      );
      // const contentDisposition = response.headers["content-disposition"];
      const FileName = response.headers["content-disposition"];
      const contentType = response.headers["content-type"];
      const blob = new Blob([response.data], { type: contentType });
      // Check if the Blob type is supported before creating an Object URL
      if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
        const arrayBuffer = await blob.arrayBuffer();
        const url = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: contentType })
        );
        // Open a new tab and set its location to the Object URL
        // window.open(url);
        const a = document.createElement("a");
        a.href = url;
        // a.download = `${FileName}.${contentType.substr(12,15)}`;
        a.download = `${filename}.pdf`;
        document.body.appendChild(a);
        // Trigger a click event to start the download
        a.click();
        // Remove the download link from the DOM
        document.body.removeChild(a);
        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } else {
        console.error(
          "Blob.arrayBuffer is not supported. Unable to create Object URL."
        );
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.warning("Unable to download file. Please try again later.");
    }
  };

  const handleDownloadEwayBill = async (params) => {
    console.log(params);
    try {
      const requestData = {
        delivery_challan_id: params,
      };

      const response = await axios.post(
        "/api/purple-fusion/deliverychallandocuments/ewaybill/downloads",
        requestData,
        {
          ...headers,
          responseType: "arraybuffer",
        }
      );

      const contentDisposition = response.headers["content-disposition"];
      const FileName = response.headers["content-disposition"];
      const contentType = response.headers["content-type"];

      // Extract file name from content disposition
      const fileNameMatch = contentDisposition.match(
        /filename=["']?([^'"\s]+)["']?/
      );
      const fileName = fileNameMatch ? fileNameMatch[1] : "download";

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: contentType });

      // Create a URL for the file
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${FileName} Eway Bill.pdf`; // Use the extracted filename directly
      document.body.appendChild(a);

      // Trigger a click event to start the download
      a.click();

      // Remove the download link from the DOM
      document.body.removeChild(a);

      // Revoke the Object URL to free up resources
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.warning("Unable to download file. Please try again later.");
      console.error("Error downloading file:", error);
    }
  };

  const GetPreview = async (params, name) => {
    try {
      const requestData = {
        id: params,
      };
      console.log(requestData);
      const response = await axios.post(
        "/api/purple-fusion/delivarychallan/preview",
        requestData,
        {
          ...headers,
          responseType: "arraybuffer",
        }
      );
      // const contentDisposition = response.headers["content-disposition"];
      const FileName = response.headers["content-disposition"];
      // const contentType = response.headers["content-type"];
      const contentType = "application/pdf";
      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: contentType });
      // Check if the Blob type is supported before creating an Object URL
      if (Blob.prototype.hasOwnProperty("arrayBuffer")) {
        const arrayBuffer = await blob.arrayBuffer();
        const url = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: contentType })
        );
        // Open a new tab and set its location to the Object URL
        window.open(url);
        // Revoke the Object URL to free up resources
        window.URL.revokeObjectURL(url);
      } else {
        console.error(
          "Blob.arrayBuffer is not supported. Unable to create Object URL."
        );
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.warning("Unable to download file. Please try again later.");
    }
  };
  const handleDelete = (params) => {
    Swal.fire({
      title: "Are you sure?",
      // text: "You won't be able to revert this!",
      html: `You want to delete 
      <span style="color: #FF5733;"></span>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            "/api/purple-fusion/delivarychallan/delete",
            { id: params },
            headers
          )
          .then((response) => {
            console.log(response.data);
            const message = response.data.message;
            if (response.data.status) {
              toast.success(message, {
                autoClose: 1000,
              });
              getAllDelivaryChallan();
            } else {
              toast.error(message, {
                autoClose: 1000,
              });
            }
          });
      }
    });
  };
  const DownloadPDF = () => {
    const docDefinition = {
      pageOrientation: "landscape",
      header: {
        text: "Delivery Challan",
        style: "header",
      },
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                [{ text: "SR.NO", style: "tableHeader", bold: true }],
                [{ text: "Code", style: "tableHeader", bold: true }],
                [{ text: "Customer Name", style: "tableHeader", bold: true }],
                [
                  {
                    text: "Delivery Challan Type",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: "Status", style: "tableHeader", bold: true }],
                [
                  {
                    text: "Delivery Challan Date",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [
                  {
                    text: "Is Cycle Completed",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: "Remark", style: "tableHeader", bold: true }],
                [{ text: "Created Date", style: "tableHeader", bold: true }],
                [{ text: "Active", style: "tableHeader", bold: true }],
              ],
              ...sorteddelivaryChallan.map((delivaryChallan, index) => [
                index + 1,
                delivaryChallan.code,
                delivaryChallan.customer_name,
                delivaryChallan.delivery_challan_type_name,
                delivaryChallan.delivery_challan_status,
                delivaryChallan.delivery_challan_date,
                delivaryChallan.is_cycle_complete,
                delivaryChallan.remark,
                delivaryChallan.createdon.substr(0, 10),
                delivaryChallan.isactive ? "Yes" : "No",
              ]),
            ],
            widths: "auto",
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
          color: "#000",
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
          // Add underline
          color: "#333",
        },
      },
    };
    pdfMake.createPdf(docDefinition).download("Delivery Challan List");
  };

  const onBtnExport = useCallback(() => {
    const options = {
      fileName: "Delivery Challan List.csv", // Specify your desired filename here
    };

    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const handleNavigation = (option) => {
    console.log("Navigate to:", option.value);
    const params = option.params;
    console.log(params);

    switch (option.value) {
      case "View":
        navigate(
          `/delivarychallanitem/list/${params.data.id}/${params.data.delivery_challan_type_id}/${params.data.customer_id}`,
          {}
        );
        break;

      case "Preview":
        GetPreview(params.data.id, params.data.code);
        break;

      case "Submit":
        SubmitTaxInvoice(params.data.id, params.data.delivery_challan_type_id);
        break;

      case "GenerateEwayBill":
        sessionStorage.setItem("name", params.data.customername);
        navigate(`/deliverychallanewaybill/generate/${params.data.id}`, {
          state: {
            sales_order_id: params.data.sales_order_id,
            customername: params.data.customername,
          },
        });
        break;

      case "DownloadOriginal":
        handleButtonClick(params.data.id, params.data.code);
        break;

      case "DownloadAll":
        handleButtonClick1(params.data.id, params.data.code);
        break;

      case "Delete":
        handleDelete(params.data.id);
        break;
      case "Edit":
        navigate(`/delivarychallan/edit/${params.data.id}`);
        break;
      case "Cancel":
        navigate(`/delivarychallan/cancel/${params.data.id}`);
        break;
      case "E-way Bill":
        handleDownloadEwayBill(params.data.id);
        break;

      default:
        break;
    }
  };

  const defaultColDefs = [
    { headerName: "Sr.No", field: "sr", width: 85 },
    {
      headerName: "CODE",
      field: "code",
      width: 180,
      cellRenderer: (params) => <Code>{params.value}</Code>,
    },
    { headerName: "Customer Name", field: "customer_name", width: 250 },
    {
      headerName: "Delivery Challan Type",
      field: "delivery_challan_type_name",
      width: 170,
    },
    {
      headerName: "Status",
      field: "delivery_challan_status",
      width: 130,

      cellRenderer: (params) => (
        <>
          <StatusCapsule
            type={
              params.data.delivery_challan_status === "Submitted"
                ? "success"
                : "error"
            }
          >
            {params.value}
          </StatusCapsule>
        </>
      ),
    },
    {
      headerName: "Supplier Deliver Challan",
      field: "supplier_delivery_challan_no",
      width: 170,
    },
    {
      headerName: "P.O CODE",
      field: "company_purchase_order_code",
      width: 170,
    },
    {
      headerName: "Delivery Challan Date",
      field: "delivery_challan_date",
      width: 170,
    },
    {
      headerName: "Is Cycle Completed",
      field: "is_cycle_complete",
      width: 130,
    },
    { headerName: "Remark", field: "remark", width: 100 },
    { headerName: "ACTIVE", field: "isactive", width: 95 },
    {
      headerName: "CREATED DATE",
      field: "createdon",
      width: 130,
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
    },
    {
      headerName: "ACTIONS",
      field: "id",
      width: "130%",
      cellRenderer: (params) => (
        <div>
          <button
            className="font-small text-blue-600 dark:text-blue-500 mt-2"
            onClick={() => {
              navigate(
                `/delivarychallanitem/list/${params.value}/${params.data.delivery_challan_type_id}/${params.data.customer_id}`,
                {}
              );
            }}
          >
            View
          </button>
          &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;
          {params.data.delivery_challan_status === "Draft" ? (
            <button
              onClick={() => {
                SubmitTaxInvoice(
                  params.value,
                  params.data.delivery_challan_type_id
                );
              }}
              className="bg-transparent hover:bg-green-500 p-1 hover:text-black-900 text-blue-700 font-semibold hover:text-white  border border-blue-500 hover:border-transparent rounded"
            >
              Submit
            </button>
          ) : null}
        </div>
      ),
    },

    {
      headerName: "PREVIEW",
      field: "id",
      cellRenderer: (params) => (
        // params.data.taxinvoicestatus== 'Submit' ? (
        <button
          className="font-small text-blue-600 dark:text-blue-500 mr-2 ml-3 mt-2.5"
          onClick={(e) => {
            GetPreview(params.value, params.data.code);
          }}
        >
          <FaEye className="w-4 h-4 ml-3" />
        </button>
      ),
      // ) : null
      width: "130%",
    },
    {
      headerName: "EWAYBILL",
      field: "id",
      cellRenderer: (params) => (
        <>
          {/* {params.data.taxinvoicestatus === 'Draft' ? null : ( */}
          {params.data.ewbno ? (
            <button class=" text-green-500 text-xs">Generated</button>
          ) : (
            <button
              onClick={() => {
                // sessionStorage.setItem("name", params.data.customername);
                navigate(`/deliverychallanewaybill/generate/${params.value}`, {
                  state: {
                    sales_order_id: params.data.sales_order_id,
                    customername: params.data.customername,
                  },
                });
              }}
              className="font-small text-blue-600 dark:text-blue-500"
            >
              <button className="text-blue-700 hover:text-black-900 border bg-transparent hover:bg-green-500 border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-small rounded-md text-xs p-1  text-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800">
                Generate EwayBill
              </button>
            </button>
          )}
        </>
      ),
      width: "140%",
    },
    {
      headerName: "ORIGINAL COPY",
      field: "id",
      cellRenderer: (params) =>
        params.data.ewbno ? (
          <button
            className="font-small text-blue-600 dark:text-blue-500 mr-2 ml-3 mt-2.5"
            onClick={(e) => {
              handleButtonClick(params.value, params.data.code);
            }}
            title="Download"
          >
            {/* Download One  */}
            <BsDownload className="w-4 h-4 ml-3" />
          </button>
        ) : null,
      // </Link>
      width: "130%",
    },
    {
      headerName: "ALL COPIES",
      field: "id",
      cellRenderer: (params) =>
        params.data.ewbno ? (
          <button
            className="font-small text-blue-600 dark:text-blue-500 mr-2 ml-3 mt-2.5"
            onClick={(e) => {
              handleButtonClick1(params.value, params.data.code);
            }}
            title="Download"
          >
            {/* Print */}
            <BsDownload className="w-4 h-4 ml-3" />
          </button>
        ) : null,
      // </Link>
      width: "130%",
    },
    {
      headerName: "DELETE",
      field: "id",
      cellRenderer: (params) =>
        params.data.delivery_challan_status !== "Submitted" &&
        params.data.delivery_challan_type_id != 5 ? (
          <button
            className="font-small text-red-600 dark:text-blue-500 mr-2 ml-3 mt-2.5"
            onClick={(e) => {
              handleDelete(params.value);
            }}
            title="Delete"
          >
            <RiDeleteBin6Line className="w-4 h-4 ml-3" />
          </button>
        ) : null,
      width: "100%",
    },
    {
      headerName: "E-WAY BILL",
      field: "id",
      cellRenderer: (params) =>
        params.data.ewbno ? (
          <button
            className="font-small text-blue-600 dark:text-blue-500 mr-2 ml-3 mt-2.5"
            onClick={(e) => {
              handleDownloadEwayBill(params.value);
            }}
            title="Download"
          >
            {/* Download One  */}
            <BsDownload className="w-4 h-4 ml-3" color="green" />
          </button>
        ) : null,
      // </Link>
      width: "130%",
    },
    {
      headerName: "ACTION",
      field: "code",
      pinned: "right",
      cellRenderer: (params) => {
        const { showActionColumn, showViewColumn } = params.context;
        const getOptions = () => {
          let options = [
            {
              value: "Preview",
              label: "Preview",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: FaFilePdf,
              params: params,
            },
          ];
          if (showViewColumn) {
            options.push({
              value: "View",
              label: "View items",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: FaEye,
              params: params,
            });
          }
          if (showActionColumn) {
            options.push({
              value: "Edit",
              label: "Edit",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: FaRegEdit,
              params: params,
            });
          }

          if (
            showActionColumn &&
            params.data.delivery_challan_status === "Draft"
          ) {
            options.push({
              value: "Submit",
              label: "Submit",
              iconColor: "rgb(34 197 94)", // Set the icon color
              labelColor: "rgb(34 197 94)", // Set the label color
              icon: FaCheck,
              params: params,
            });
          }

          if (params.data.ewbno) {
            options.push({
              value: "DownloadOriginal",
              label: "Download Original Copy",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: BsDownload,
              params: params,
            });

            options.push({
              value: "DownloadAll",
              label: "Download All Copies",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: BsDownload,
              params: params,
            });

            options.push({
              value: "E-way Bill",
              label: "E-way Bill",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: BsDownload,
              params: params,
            });
          }

          if (
            showActionColumn &&
            params.data.delivery_challan_status !== "Submitted"
          ) {
            options.push({
              value: "Delete",
              label: "Delete",
              iconColor: "rgb(239 68 68)", // Set the icon color
              labelColor: "rgb(239 68 68)", // Set the label color
              icon: RiDeleteBin6Line,
              params: params,
            });
          }
          // if (params.data.delivery_challan_status === "Submitted") {
          //   options.push({
          //     value: "Cancel",
          //     label: "Cancel",
          //     iconColor: "rgb(239 68 68)", // Set the icon color
          //     labelColor: "rgb(239 68 68)", // Set the label color
          //     icon: RiDeleteBin6Line,
          //     params: params,
          //   });
          // }

          if (
            params.data.delivery_challan_status === "Submitted" &&
            !params.data.ewbno
          ) {
            options.push({
              value: "GenerateEwayBill",
              label: "Generate EwayBill",
              iconColor: "rgb(59 130 246)", // Set the icon color
              labelColor: "rgb(59 130 246)", // Set the label color
              icon: BsBoxArrowInRight,
              params: params,
            });
          }

          return options;
        };

        const options = getOptions();

        return (
          <div style={{ width: "100%", position: "relative", zIndex: 999 }}>
            <Select
              options={options}
              isSearchable={false}
              onChange={handleNavigation}
              placeholder={params.value || "ACTION"}
              menuPlacement="bottom"
              menuPortalTarget={selectRef.current} // Render the menu in the body
              styles={updatedActionButtonCustomStyle}
              // styles={actionbuttonCustomStyle}
              value={null} // Ensure no value is selected
              components={{ Option: CustomOption }} // Use the custom option component
            />
          </div>
        );
      },
      width: 180,
    },
  ];

  const customColDefs = [
    ...defaultColDefs,
    {
      headerName: "EDIT",
      field: "id",
      width: 80,
      cellRenderer: (params) => (
        <div>
          <button
            className="font-small text-blue-600 dark:text-blue-500 mr-2 ml-3 mt-2"
            onClick={() => {
              navigate(`/delivarychallan/edit/${params.value}`);
            }}
          >
            <FaRegEdit />
          </button>
        </div>
      ),
    },

    {
      headerName: "EDIT DC TYPE",
      field: "id",
      width: 110,
      cellRenderer: (params) => (
        <div>
          {params.data.delivery_challan_type_id == 3 && (
            <button
              className="font-small text-blue-600 dark:text-blue-500 mr-2 ml-3 mt-2"
              onClick={() => {
                // navigate(`/delivarychallan/edit/${params.value}`);
                updateDeliveryChallanType(params.value);
              }}
            >
              EDIT DC TYPE
            </button>
          )}
        </div>
      ),
    },
  ];

  const [colDefs, setColDefs] = useState([]);
  useEffect(() => {
    setColDefs(
      showActionColumn
        ? showViewColumn
          ? customColDefs
          : customColDefs.filter((col) => col.headerName !== "ACTIONS")
        : showViewColumn
        ? defaultColDefs
        : defaultColDefs.filter((col) => col.headerName !== "ACTIONS")
    );
  }, [showActionColumn, showViewColumn]);

  const ColDefaultVale = { filter: true };

  //for option change...
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
  };
  //CustomeStyle of Ag Grid...
  const customeStyle = { height: 480, width: "100%", fontSize: "12px" };
  const updatedActionButtonCustomStyle = {
    ...actionbuttonCustomStyle,
    menu: (base) => ({
      ...base,
      marginTop: "0px", // Change the marginTop as needed
      marginRight: "100px", // Change the marginRight as needed
      marginBottom: "0", // Change the marginBottom as needed
      marginLeft: "0px", // Change the marginLeft as needed
      paddingTop: "0", // Change the paddingTop as needed
      paddingRight: "0", // Change the paddingRight as needed
      paddingBottom: "0", // Change the paddingBottom as needed
      paddingLeft: "0", // Change the paddingLeft as needed
      zIndex: 9999, // Keep the existing zIndex or modify as needed
    }),
  };
  const gridOptions = {
    overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
  };

  return (
    <>
      {showPageView ? (
        <div className="overflow-hidden">
          <div className="flex  flex-row w-full items-center p-2">
            <Text
              className="md:text-[22px] whitespace-nowrap text-gray-800 sm:text-xl tracking-[0.20px] w-[85px] text-base"
              size="txtInterSemiBold24"
            >
              {" "}
              Delivery Challan
            </Text>

            {/* Search Fuctionallity.. */}
            <Text
              className="text-sm md:text-[22px] whitespace-nowrap text-gray-600 sm:text-xl tracking-[0.20px] ml-20 mr-1"
              size="txtInterSemiBold24"
            >
              {" "}
              Search By :
            </Text>

            <div className="flex gap-2 items-center justify-center">
              <input
                type="radio"
                id="column"
                name="option"
                checked={selectedOption === "column"}
                onChange={(event) => {
                  handleOptionChange(event);
                  setsearchCompanySpecificDateRangeId("");
                  setsearchParameter("");
                  setPage(1);
                }}
                className="scale-100"
              />
              <label className=" text-gray-600  text-sm"> Column</label>

              <input
                type="radio"
                className="scale-100 "
                id="date"
                name="option"
                checked={selectedOption === "date"}
                onChange={(event) => {
                  handleOptionChange(event);
                  setsearchCompanySpecificCriteriaId("");
                  setsearchParameter("");
                  setPage(1);
                }}
              />
              <label className=" text-gray-600 text-sm"> Date</label>

              {selectedOption === "column" && (
                <Select
                  options={searchCompanySpecificCriteria.map((resstate) => ({
                    label: resstate.criteria,
                    value: resstate.id,
                  }))}
                  className="bg-white-A700 border border-gray-200_02"
                  onChange={(selectedoption) => {
                    setsearchCompanySpecificCriteriaId(selectedoption.value);
                    setPage(1);
                  }}
                  defaultValue={
                    searchCompanySpecificCriteria.length > 0
                      ? {
                          label: searchCompanySpecificCriteria[0].criteria,
                          value: searchCompanySpecificCriteria[0].id,
                        }
                      : {
                          label: "Customer Name", // Set default label when there are no criteria
                          value: null, // Set value to null or a default id if necessary
                        }
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "30px", // Adjust the height as needed
                      // minHeight: '10px', // Ensure the minimum height is also set
                      width: "140px", // Adjust the width as needed
                      display: "flex",
                      alignItems: "center", // Center vertically
                      justifyContent: "center", // Center horizontally
                    }),
                  }}
                />
              )}

              {selectedOption === "date" && (
                <Select
                  options={searchcompanyspecificdaterange.map((resstate) => ({
                    label: resstate.date_range,
                    value: resstate.search_date_range_id,
                  }))}
                  className="bg-white-A700 border border-gray-200_02 "
                  onChange={(selectedoption) => {
                    setsearchCompanySpecificDateRangeId(selectedoption.value);
                    setPage(1);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "30px", // Adjust the height as needed
                      //  minHeight: '10px', // Ensure the minimum height is also set
                      width: "140px", // Adjust the width as needed
                      display: "flex",
                      alignItems: "center", // Center vertically
                      justifyContent: "center", // Center horizontally
                    }),
                  }}
                />
              )}

              {selectedOption === "column" && (
                <input
                  name="searchParamater"
                  type="text"
                  placeholder="Search..."
                  onChange={(e) => {
                    setsearchParameter(e.target.value);
                    setPage(1);
                  }}
                  // onChange={formik.handleChange}
                  className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-40"
                ></input>
              )}

              {selectedOption === "date" &&
                searchCompanySpecificDateRangeId === 7 && (
                  <div className="flex flex-row">
                    <input
                      name="from_date"
                      type="date"
                      onChange={(e) => {
                        setFormDate(e.target.value);
                        setsearchParameter2(
                          e.target.value.concat("@" + toDate)
                        );
                        setPage(1);
                      }}
                      className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[40%]  pt-4"
                    />
                    <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2  ">
                      To
                    </Text>

                    <input
                      name="to_date"
                      type="date"
                      onChange={(e) => {
                        setToDate(e.target.value);
                        setsearchParameter2(
                          formDate.concat("@" + e.target.value)
                        );
                        setPage(1);
                      }}
                      className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px]   pt-4"
                    />
                  </div>
                )}
            </div>

            <div className="flex text-3xl relative flex-row justify-end items-center font-inter gap-2 px-[10px] w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white">
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    className="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[125px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    className="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={DownloadPDF}
                      >
                        PDF
                      </span>
                    </li>
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={onBtnExport}
                      >
                        Excel
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              {erplist.some(
                (item) => item.erp_module_id === 51 && item.add
              ) && (
                <Link to={`/delivarychallan/add`}>
                  <div className="flex flex-col items-center justify-center">
                    <button
                      type="button"
                      id="dropdownDefaultButton"
                      className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
                    >
                      + Add
                    </button>
                  </div>
                </Link>
              )}
            </div>
          </div>
          <ToastContainer />
          <div
            className="ag-theme-quartz"
            id="my-table1"
            // style={customeStyle}
            ref={selectRef}
            // style={{ height: 550, width: "100%", fontSize: "12px" }}
          >
            <AgGridReact
              ref={gridRef}
              rowData={sorteddelivaryChallan.map((delivaryChallan, index) => ({
                ...delivaryChallan,
                supplier_name:
                  delivaryChallan.supplier_name !== null
                    ? delivaryChallan.supplier_name
                    : "NA",
                customer_name:
                  delivaryChallan.customer_name !== null
                    ? delivaryChallan.customer_name
                    : "NA",
                sub_contractor_name:
                  delivaryChallan.sub_contractor_name !== null
                    ? delivaryChallan.sub_contractor_name
                    : "NA",
                sr: index + (offsetforSR + 1),
              }))}
              // rowData={bom}
              columnDefs={colDefs}
              context={{ showActionColumn, showViewColumn }} // Pass `showActionColumn` through context
              // pagination={true}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              // gridOptions={gridOptions}

              overlayLoadingTemplate={loading ? "Loading..." : null}
              overlayNoRowsTemplate={
                loading
                  ? ' <img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" style="width: 50px; height: 50px;">'
                  : "No Record Found"
              }
            />
          </div>
          <div>
            <Pagination
              count={count}
              setRecordPerPage={setRecordPerPage}
              recordPerPage={recordPerPage}
              setLoading={setLoading}
              setData={setDelivaryChallan}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default DelivaryChallanList;
